/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomProductInfoPaymentResponseDtoDto } from '../models/pom-product-info-payment-response-dto-dto';


/**
 * the ProductInfoPayment API
 */
@Injectable({
  providedIn: 'root',
})
export class ProductInfoPaymentService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation productInfoPayment
   */
  static readonly ProductInfoPaymentPath = '/product/{code}/version/{version}/payment';

  /**
   * Returns product payment information for pointed out product version and code
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productInfoPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  productInfoPayment$Response(params: {

    /**
     * Product code
     */
    code: string;

    /**
     * Product version
     */
    version: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomProductInfoPaymentResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductInfoPaymentService.ProductInfoPaymentPath, 'get');
    if (params) {
      rb.path('code', params.code, {});
      rb.path('version', params.version, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomProductInfoPaymentResponseDtoDto>;
      })
    );
  }

  /**
   * Returns product payment information for pointed out product version and code
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productInfoPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productInfoPayment(params: {

    /**
     * Product code
     */
    code: string;

    /**
     * Product version
     */
    version: number;
  },
  context?: HttpContext

): Observable<PomProductInfoPaymentResponseDtoDto> {

    return this.productInfoPayment$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomProductInfoPaymentResponseDtoDto>) => r.body as PomProductInfoPaymentResponseDtoDto)
    );
  }

}
